exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".new-comment[data-v-4c83afbf] {\n  height: 150px;\n  border-radius: 5px;\n}\n", ""]);

